export enum ContactGroupAddressType {
  BILL_TO = 'bill_to',
  SHIP_TO = 'ship_to',
  SOLD_TO = 'sold_to',
}
